// Stand-ins for a box left empty, so that the range is also read correctly by
// an API that takes an empty text for the age 0.
const NO_MIN_AGE = '0'
const NO_MAX_AGE = '150'

/**
 * The age filter as it is sent to the API. An empty box means "no limit on
 * that side"; two empty boxes mean no age filter at all (undefined), which is
 * also what the filter badge counts.
 */
export const normalizeAgeRange = (range?: [string, string]): [string, string] | undefined => {
  const min = (range?.[0] ?? '').replace(/\D/g, '')
  const max = (range?.[1] ?? '').replace(/\D/g, '')

  if (!min && !max) return undefined
  if (!max) return [min, NO_MAX_AGE]
  if (!min) return [NO_MIN_AGE, max]
  // A minimum above the maximum is sent in the right order.
  return Number(min) <= Number(max) ? [min, max] : [max, min]
}
